import React from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import CartLoader from "../../../components/CartLoader";
import CartQuantityLoader from "../../../components/CartQuantityLoader";

interface SolutionBoxesProp {
  boxes?: number | any;
  price?: string | any;
  temp_cart_id?: number | any;
  cart_id: number | any;
  compare_at_price?: string | any;
}

export const SolutionBoxes = (props: SolutionBoxesProp) => {
  const { updateCartItem, isCartLoadingData } = useShoppingCart();
  const increaseQuantity = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: parseInt(props.boxes) + 1,
    powerType: "Solution",
  };

  const decreaseQuantity = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: parseInt(props.boxes) - 1,
    powerType: "Solution",
  };

  return (
    <>
      <div className="solutionPrice quantityPrice">
        <div className="eyeSpecs">
          <span className="eyeHeading quantity_heading">Quantity</span>
          <span className="quantityCount">
            {/* {isCartLoadingData && <CartQuantityLoader /> }         */}
            <button
              onClick={
                parseInt(props.boxes) > 1
                  ? () => updateCartItem(decreaseQuantity)
                  : undefined
              }
            >
              -
            </button>
            {parseInt(props.boxes)}
            <button onClick={() => updateCartItem(increaseQuantity)}>+</button>
          </span>
        </div>

        <div className="itemPrice">
          {/* <span className="itemPriceCompare">Rs. 300 </span> */}
          <span className="itemPriceCompare">
            Rs. {props.compare_at_price * parseInt(props.boxes)}{" "}
          </span>
          <span className="itemPriceSelling">
            Rs. {props.price * parseInt(props.boxes)}
          </span>
        </div>
      </div>
    </>
  );
};
